(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.dataset.stickyType === 'always' || this.dataset.stickyType === 'reduce-logo-size';
      this.setHeaderHeight = () => document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.addEventListener('preventHeaderReveal', () => (this.preventReveal = true));
      window.addEventListener('scroll', this.onScrollHandler, false);
      new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      }).observe(this.header);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.headerBounds) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeOpenMenus();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
        if (!this.preventReveal) this.header.classList.remove('shopify-section-header-hidden');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
      this.currentScrollTop = scrollTop;
    }
    closeOpenMenus() {
      this.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());
      const searchModal = this.querySelector('details-modal');
      if (searchModal) searchModal.close(false);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
